import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";

//Components
import { Button, Modal, ModalBody, ModalFooter, Tabs, TabContainer } from "@gpstrackit/react-controls";
import { NotificationManager } from "Components/Notifications";
import { Grid } from "@mui/material";

//Actions
import {
    saveVidfleetConfigurationPreview,
    reset
} from './redux/slice';
const ConfirmVidFleetConfigurationPreview = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);

    //Redux States
    const { openModal, loading, data, result, error } = useSelector(state => state.configurationPreviewRedux)

    const closeModal = () => {
        dispatch(reset())
    }

    const applyChanges = () => {
        dispatch(saveVidfleetConfigurationPreview(data))
    }

    useEffect(() => {
        if (result) {
            if (result?.resolve) {
                NotificationManager.success(messages['configuration_preview_success_message'], messages['configuration_preview_title'], 3000);
                closeModal()
                props.updateaAfterSave && props.updateaAfterSave()
            } else {
                NotificationManager.error(messages['configuration_preview_error_message'], messages['configuration_preview_title'], 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            NotificationManager.error(messages['configuration_preview_error_message'], messages['configuration_preview_title'], 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    return (
        <Modal
            open={openModal}
            title={messages['configuration_preview_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <Tabs tab={tab} onChange={(numberTab) => setTab(numberTab)} scrollButtons>
                    {
                        data?.optionLabels?.length > 0 &&
                        <TabContainer
                            label={messages['vidfleet_configuration_label_options']}
                            index={0}
                        >
                            <div style={{ padding: '5px 10px', marginTop: 10, marginBottom: 20 }}>
                                <span style={{ fontWeight: "bold" }}>{messages["vidfleet_configuration_options_changed"]}</span>
                                {
                                    data.optionLabels.map((item, index) => {
                                        return (
                                            <Grid xs={12}>
                                                <label htmlFor={index}>
                                                    {item}
                                                </label>
                                            </Grid>
                                        )
                                    })
                                }
                            </div>
                        </TabContainer>
                    }
                    <TabContainer
                        label={messages['vidfleet_configuration_json_options']}
                        index={data?.optionLabels?.length ? 1 : 0}
                    >
                        <div style={{ marginTop: 10, marginBottom: 10 }}>
                            {data?.config ?
                                <pre>
                                    {JSON.stringify(data.config, undefined, 2)}
                                </pre>
                                : <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
                        </div>
                    </TabContainer>
                </Tabs>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_close']}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['configuration_preview_save_changes']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmVidFleetConfigurationPreview;